import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import BulkEmail from '../../components/bulk-email/bulk-email.component';

const BulkEmailView = () => {
  const pageTitle = PAGE_TITLE_LIST.BULK_EMAIL;

  return (
    <AppLayout pageTitle={pageTitle}>
      <BulkEmail />
    </AppLayout>
  );
};

export default BulkEmailView;
